
<div class="row" *ngIf="displayTimeLineChart">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  p-0 mb-5">

        <div class="row pt-5">
            <div class="col-12 text-center">
                <h3>{{ 'pages.securitycase.casesTimeline' | translate }}
                    <app-help message="{{ 'pages.securitycase.caseTimelineDesc' | translate }}"></app-help>
                </h3>
            </div>
             
        </div>
        <div class="row p-0" [ngClass]="{'selected': pointSelected}">
            <div class="col-2 text-center p-0">
                <div class="heading-div">
                    <p class="heading-paragraphs" [ngClass]="{'active': pointSelected?.yIndex === 0}"><span class="label">{{ 'pages.securitycase.customer' | translate }}</span></p>
                    <p class="heading-paragraphs" [ngClass]="{'active': pointSelected?.yIndex === 1}"><span class="label">Orange Cyberdefense</span></p>
                </div>
            </div>
            <div class="col-10">

                <highcharts-chart 
                [Highcharts]="Highcharts"
                [options]="timeLineChart"
                [(update)]="updateDonutFlag"
                style="margin-left:10% ;width: 80%; max-width:1050px;height: 400px; display: block;"
                ></highcharts-chart>
                <div class="stage-div">
                    <div class="step">
                        <img src="assets/images/timeline-underinv.png" alt="Under Investigation" title="Under Investigation" [ngClass]="{'active': pointSelected?.xIndex === 0}" width="100%">
                        <div class="caption">{{ 'pages.securitycase.underInvestigation' | translate }}</div>
                    </div>
                    <div class="step">
                        <img src="assets/images/timeline-escalated.png" alt="Escalated" title="Escalated" [ngClass]="{'active': pointSelected?.xIndex === 1}" width="100%">
                        <div class="caption">{{ 'pages.securitycase.escalated' | translate }}</div>
                    </div>
                    <div class="step">
                        <img src="assets/images/timeline-pendingocd.png" alt="Pending OCD" title="Pending OCD" [ngClass]="{'active': pointSelected?.xIndex === 2}" width="100%">
                        <div class="caption"> {{ 'pages.securitycase.pendingOcd' | translate }} </div>
                    </div>
                    <div class="step">
                        <img src="assets/images/timeline-closed.png" alt="Closed" title="Closed" [ngClass]="{'active': pointSelected?.xIndex === 3}" width="100%">
                        <div class="caption">{{ 'pages.securitycase.closed' | translate }}</div>
                    </div>
                    
                </div>
            </div>
           
        </div>
        
    </div>
</div>



<div class="row pt-3" *ngIf="showCases.length > 0">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-12">

                <div class="row faketableheaderrow">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 faketableheader" >
                        {{'pages.securitycase.caseNumber' | translate}} 
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 d-none d-md-block faketableheader" >
                        {{'pages.securitycase.status' | translate}} 
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketableheader" >
                        {{'pages.securitycase.subject' | translate}} 
                    </div>
                   
                </div>

                <div class="row faketablerow" *ngFor="let case of showCases" [routerLink]="['/support/view/' + case.id]" routerLinkActive="activeLink">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 faketablecell">
                        {{case.caseNumber}}
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-4 d-none d-md-block faketablecell">
                        {{case.status}}
                    </div> 
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketablecell">
                        {{case.subject}}
                    </div>
                 
                </div>

            </div>
        </div>
    
    </div>
</div>


<div class="row mt-5 justify-content-center p-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>